var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "point-page" },
    [
      _c(
        "div",
        { staticClass: "well_box" },
        [
          _c("p", { staticClass: "sub_title img" }, [
            _vm._v("\n      Basic Information\n      "),
            ["OIL", "ALL"].includes(this.pageData.type)
              ? _c("img", {
                  staticStyle: {
                    width: "0.66rem",
                    height: "0.24rem",
                    "margin-left": "0.15rem",
                  },
                  attrs: {
                    src: require("@/assets/image/well/oil.png"),
                    alt: "",
                    srcset: "",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            ["GAS", "ALL"].includes(this.pageData.type)
              ? _c("img", {
                  staticStyle: {
                    width: "0.66rem",
                    height: "0.24rem",
                    "margin-left": "0.15rem",
                  },
                  attrs: {
                    src: require("@/assets/image/well/gas.png"),
                    alt: "",
                    srcset: "",
                  },
                })
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "addWellForm",
              staticClass: "page-form point-form",
              attrs: { model: _vm.pageData, "label-position": "left" },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 40 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Unique ID:" } },
                        [_c("account", { attrs: { value: _vm.uniqueId } })],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "nickname", label: "Well Name:" } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.pageData.nickname) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 24 } }),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "UWI", label: "AER UWI:" } },
                        [
                          _vm.pageData.status === 1
                            ? _c(
                                "div",
                                { staticClass: "tip_box" },
                                [
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        placement: "top",
                                        content: "The value is encrypted.",
                                      },
                                    },
                                    [
                                      _c("svg-icon", {
                                        staticClass: "tip_btn",
                                        staticStyle: { left: "0.78rem" },
                                        attrs: { "icon-class": "ts" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("account", {
                                    staticClass: "tip_val",
                                    attrs: { value: _vm.pageData.UWI },
                                  }),
                                ],
                                1
                              )
                            : _c("span", [_vm._v(_vm._s(_vm.pageData.UWI))]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "fromToIDIdentifier",
                            label: "FromToIDIdentifier:",
                          },
                        },
                        [
                          _vm.pageData.status === 1
                            ? _c(
                                "div",
                                { staticClass: "tip_box" },
                                [
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        placement: "top",
                                        content: "The value is encrypted.",
                                      },
                                    },
                                    [
                                      _c("svg-icon", {
                                        staticClass: "tip_btn",
                                        staticStyle: { left: "1.56rem" },
                                        attrs: { "icon-class": "ts" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("account", {
                                    staticClass: "tip_val",
                                    attrs: {
                                      value: _vm.pageData.fromToIDIdentifier,
                                    },
                                  }),
                                ],
                                1
                              )
                            : _c("span", [
                                _vm._v(_vm._s(_vm.pageData.fromToIDIdentifier)),
                              ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 24 } }),
                  _vm._v(" "),
                  _vm.pageData.type === "OIL"
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "sulphur",
                                label: "Sulphur Content:",
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.pageData.sulphur) +
                                  " %\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.pageData.type === "OIL"
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "APIGravity",
                                label: "API Gravity:",
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.pageData.APIGravity) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.pageData.type === "OIL" && _vm.pageData.oilAnalysis
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "oilAnalysis",
                                label: "Oil Analysis:",
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openPdfView("oilAnalysis")
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.pageData.oilAnalysis) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.pageData.wellLisence
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "wellLisence",
                                label: "Well Licence:",
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openPdfView("wellLisence")
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.pageData.wellLisence) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "sub_title" }, [
            _c(
              "div",
              [
                _vm._v("\n        Beneficiary Information\n        "),
                _c(
                  "el-tooltip",
                  { attrs: { placement: "top" } },
                  [
                    _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                      _vm._v(
                        "\n            1. Please ensure that the beneficiary's account is true, accurate, and\n            carefully distributed;"
                      ),
                      _c("br"),
                      _vm._v(
                        "2. After the Rep is minted successfully, it will\n            be automatically sent to the beneficiary's account according to the ratio\n            you set.\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("svg-icon", { attrs: { "icon-class": "ts" } }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-table",
            { attrs: { data: _vm.pageData.beneficiaries } },
            [
              _c("el-table-column", {
                attrs: { label: "No.", align: "center", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.isOwner(scope.row)
                          ? _c("svg-icon", {
                              attrs: { "icon-class": "share_user" },
                            })
                          : _vm._e(),
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.$index + 1) +
                            "\n          "
                        ),
                        _vm.isOwner(scope.row)
                          ? _c("span", [_vm._v("(YOU)")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "tnEthAccount", label: "Beneficiar" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "ratio", label: "Benefit ratio", width: "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(" " + _vm._s(row.ratio) + "% ")]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("pdfView", { ref: "pdfView" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }